import httpRequest from '../../../../../modules/Gull/Framework/httpRequest.js';
import validators from '../../../../../modules/Gull/Framework/validators.js';

const edit = {
	/**
	 * ID's die gevuld worden vanuit de DOM in de init functie
	 */
	meldingId: null,
	werknemerId: null,

	/**
	 * DOM elements
	 */
	elementAlertOverlappendeMelding: document.getElementById('alertOverlappendeMelding'),
	elementAlertGeenActiefDienstverband: document.getElementById('alertGeenActiefDienstverband'),
	elementAlertDienstverbandMetEinddatum: document.getElementById('alertDienstverbandMetEinddatum'),
	elementFormDetails: document.querySelector('[data-form-section="details"]'),
	elementInputBeginDatum: document.getElementById('Begindatum'),
	elementInputType: document.getElementById('Type'),
	elementTextDienstverbandEinddatum: document.getElementById('dienstverbandEinddatum'),

	/**
	 * Function: init
	 * Initial function to run when the page is loaded
	 * This function will set the initial values for the edit object
	 *
	 * @returns {void}
	 */
	init: function () {
		if (document.getElementById('form-melding') !== null) {
			edit.meldingId = document.getElementById('form-melding').getAttribute('data-melding_id');
			edit.werknemerId = document.getElementById('form-melding').getAttribute('data-werknemer_id');

			edit.initEvents();
			edit.getDienstverleners();
		}
	},

	/**
	 * Function: initEvents
	 * This function will initialize the events for the edit page
	 *
	 * @returns {void}
	 */
	initEvents: function () {
		$('#Type').change(function () {
			edit.getDienstverleners();
		});

		$('#Begindatum').on('change', function (event) {
			edit.begindatumChangeEventHandler(event);
		});

		$('#Begindatum').on('keyup', function (event) {
			edit.begindatumKeyupEventHandler(event);
		});
	},

	/**
	 * Function: begindatumChangeEventHandler
	 * This function will handle the change event for the begindatum input
	 *
	 * @param {Event} event - The event object
	 *
	 * @returns {void}
	 */
	begindatumChangeEventHandler: function (event) {
		if (validators.date(edit.elementInputBeginDatum.value) === 'success') {
			edit.checkBegindatum();
		}
	},

	/**
	 * Function: begindatumKeyupEventHandler
	 * This function will handle the keyup event for the begindatum input
	 *
	 * @param {Event} event - The event object
	 *
	 * @returns {void}
	 */
	begindatumKeyupEventHandler: function (event) {
		const key = event.key;
		if ((key >= '0' && key <= '9') || key === '-') {
			if (validators.date(edit.elementInputBeginDatum.value) === 'success') {
				edit.checkBegindatum();
				$(event.target).datepicker('hide');
			}
		}
	},

	/**
	 * Function: checkBegindatum
	 * This function will check the begindatum for the current melding
	 * and show the correct alerts if needed
	 *
	 * @returns {void}
	 */
	checkBegindatum: function () {
		const url = window.app.ajaxPath + edit.werknemerId + '/' + edit.meldingId + '/duplicate-check/' + edit.elementInputBeginDatum.value + '/' + edit.meldingId + '/';
		httpRequest.send('POST', url, function (data) {
			data = JSON.parse(data);
			if (!data.success) {
				edit.hideAlertsAndFormSections();
				edit.elementInputBeginDatum.setAttribute('disabled', true);
				if (data.duplicate != false) {
					edit.showAlertOverlappendeMelding(data);
				} else if (data.dienstverband == false) {
					edit.showAlertGeenActiefDienstverband();
				} else if (data.dienstverband_einddatum !== false) {
					edit.showAlertDienstverbandMetEinddatum(data);
				} else {
					edit.elementFormDetails.classList.remove('d-none');
				}
				edit.elementInputBeginDatum.removeAttribute('disabled');
			}
		});
		edit.getDienstverleners();
	},

	/**
	 * Function: hideAlertsAndFormSections
	 * This function will hide all alerts and the form details
	 *
	 * @returns {void}
	 */
	hideAlertsAndFormSections: function () {
		edit.elementAlertOverlappendeMelding.classList.add('d-none');
		edit.elementAlertGeenActiefDienstverband.classList.add('d-none');
		edit.elementAlertDienstverbandMetEinddatum.classList.add('d-none');
		edit.elementFormDetails.classList.add('d-none');
	},

	/**
	 * Function: showAlertOverlappendeMelding
	 * This function will show the alert for overlapping meldingen
	 *
	 * @returns {void}
	 */
	showAlertOverlappendeMelding: function (data) {
		edit.elementAlertOverlappendeMelding.classList.remove('d-none');
		document.querySelectorAll('.gevonden-melding *').forEach((el) => (el.innerHTML = ''));
		data.duplicate.forEach(function (val) {
			var tr = document.createElement('tr');
			tr.innerHTML = '<td>' + val.begindatum + '</td><td>' + val.einddatum + '</td><td>' + val.type + '</td><td>' + val.action + '</td>';
			document.querySelector('.gevonden-melding').appendChild(tr);
		});
	},

	/**
	 * Function: showAlertGeenActiefDienstverband
	 * This function will show the alert for no active dienstverband
	 *
	 * @returns {void}
	 */
	showAlertGeenActiefDienstverband: function () {
		edit.elementAlertGeenActiefDienstverband.classList.remove('d-none');
	},

	/**
	 * Function: showAlertDienstverbandMetEinddatum
	 * This function will show the alert for dienstverband met einddatum
	 *
	 * @param {Object} data - The data object containing the dienstverband_einddatum value.
	 *
	 * @returns {void}
	 */
	showAlertDienstverbandMetEinddatum: function (data) {
		edit.elementTextDienstverbandEinddatum.innerHTML = data.dienstverband_einddatum;
		edit.elementAlertDienstverbandMetEinddatum.classList.remove('d-none');
		edit.elementFormDetails.classList.remove('d-none');
	},

	/**
	 * Function: getDienstverleners
	 * This function will get the dienstverleners for the current melding
	 *
	 * @returns {void}
	 */
	getDienstverleners: function () {
		const url = window.app.ajaxPath + edit.werknemerId + '/' + edit.meldingId + '/get-dienstverleners/' + edit.elementInputBeginDatum.value + '/' + edit.elementInputType.value + '/';
		httpRequest.send('POST', url, function (data) {
			data = JSON.parse(data);
			if (!data.success) {
				edit.listDienstverleners(data);
			}
		});
	},

	/**
	 * Function: listDienstverleners
	 * This function will list the dienstverleners for the current melding
	 *
	 * @param {Object} data - The data object containing the dienstverleners.
	 *
	 * @returns {void}
	 */
	listDienstverleners: function (data) {
		if (data.length === 0) {
			document.querySelector('[data-form-section=dienstverleners]').classList.add('d-none');
		} else {
			const parentElement = document.querySelector('[data-dienstverleners]');
			const existingElements = document.querySelectorAll('[data-dienstverlener-item]');
			const cloneElement = parentElement.querySelector('[data-dienstverlener-item-parent]');

			existingElements.forEach((el) => el.remove());
			parentElement.classList.remove('d-none');

			data.forEach(function (v) {
				let clone = cloneElement.cloneNode(true);
				clone.removeAttribute('data-dienstverlener-item-parent');
				clone.setAttribute('data-dienstverlener-item', '');
				clone.classList.remove('d-none');
				let nameTarget = clone.querySelector('[data-dienstverlener-naam]');
				let connectorTarget = clone.querySelector('[data-dienstverlener-connector-actief]');
				nameTarget.value = v.naam;
				if (v.connectorActief === true) {
					connectorTarget.classList.remove('d-none');
				}
				parentElement.appendChild(clone);
			});

			document.querySelector('[data-form-section=dienstverleners]').classList.remove('d-none');
		}
	},
};

export default edit;
